import { render, staticRenderFns } from "./ProtectedCover.vue?vue&type=template&id=e9d6e486&scoped=true"
import script from "./ProtectedCover.vue?vue&type=script&lang=js"
export * from "./ProtectedCover.vue?vue&type=script&lang=js"
import style0 from "./ProtectedCover.vue?vue&type=style&index=0&id=e9d6e486&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d6e486",
  null
  
)

export default component.exports